// Stage 200: render-null mount surface for the Laughter subscriber.
//
// Mounted in AuthedApp.tsx as a sibling to LargeDotWidget and WarpWidget.
// Renders nothing. Its sole purpose is to attach useLaughterSubscriber
// to the React tree so the hook's useEffect runs on snapshot changes.
//
// When `enabled === false`, the hook still mounts but its useEffect
// short-circuits at the gate (zero work). We deliberately keep the
// hook mounted-but-gated rather than unmounting the component, so that
// flipping `laughter_enabled` from false → true does not trigger a
// fresh subscription that would replay any current turn — the next
// turnEnded transition is what produces engrams, not the toggle.

import { useLaughterSubscriber } from './useLaughterSubscriber';
import type { MoodInfo } from '../../hooks/useChat';

interface LaughterSubscriberProps {
  enabled: boolean;
  conversationId: string | null;
  userMessage: string | null;
  personaResponse: string | null;
  /** Stage 201-X: gates the useLaughterPulse write-through. */
  warpMarkerEnabled: boolean;
  /** Stage 201-P: gates the cross-pillar correlation snapshot. */
  correlationsEnabled: boolean;
  /** Stage 201-P: latest assistant message's MoodInfo, or null. */
  lastMood: MoodInfo | null;
}

export function LaughterSubscriber(props: LaughterSubscriberProps): null {
  useLaughterSubscriber(props);
  return null;
}
